/**
 * Native platform types that require special handling by the app
 */
export const AndroidNativePlatformType = 'android';

/**
 * Native platform types that require special handling by the app
 */
export const IosNativePlatformType = 'ios';

/**
 * Native platform types that require special handling by the app
 */
export const NativePlatformTypes = {
  /**
   * Android platform
   */
  Android: AndroidNativePlatformType,
  /**
   * iOS platform
   */
  IOS: IosNativePlatformType,
};
